import { throttle, pageLoaded, wrapElementWidthHeight, preloader } from './helpers.js';
import anime from 'animejs';

export function scrollContainer({
                                    sectionSelector,
                                    wrapperSelector,
                                    duration = 1000,
                                    easing = 'easeInOutQuad',
                                    onBegin = null,
                                    onComplete = null
                                } = {}) {

    const section = document.querySelector(sectionSelector);
    const wrapper = document.querySelector(wrapperSelector);

    const state = {
        slider: 1, // slider index
        scrollPosition: 0,
        sectionHeight: section.offsetHeight,
        animating: false,
        contentEl: wrapper,
        scrollReachedEndPosition: 'up',
        beforeInitStyles: {},
        scroll: {
            position: 0,
            clicked: false,
            lastDeltaY: 0
        },
    };

    function animate(direction, element = null) {
        let { scrollPosition, sectionHeight, animating, contentEl, scrollReachedEndPosition } = state;
        if (animating || direction === scrollReachedEndPosition) return;

        let newPosition = direction === 'down' ? scrollPosition + sectionHeight : scrollPosition - sectionHeight;

        state.animating = true;

        anime({
            targets: contentEl,
            scrollTop: [scrollPosition, newPosition],
            duration: duration,
            easing: easing,
            begin: function (anim) {
                if (onBegin) onBegin(state.slider, anim, direction === 'down' ? state.slider + 1 : state.slider - 1);
            },
            complete: function (anim) {
                state.animating = false;
                state.scrollPosition = newPosition;
                state.scrollReachedEndPosition = calcScrollPosition();
                direction === 'down' ? state.slider++ : state.slider--;
                if (onComplete) onComplete(state.slider, anim);
                if (state.scroll.clicked) scrollClear();
            },
        });
    }

    function clickOfElement(element) {
        let { scrollPosition, sectionHeight, animating, contentEl, scrollReachedEndPosition } = state;

        const sections = document.querySelectorAll(wrapperSelector + ' ' + sectionSelector);
        let newPosition = sections[element].offsetTop;

        state.animating = true;

        anime({
            targets: contentEl,
            scrollTop: [scrollPosition, newPosition],
            duration: duration,
            easing: easing,
            begin: function (anim) {
                if (onBegin) onBegin(state.slider, anim, element + 1);
            },
            complete: function (anim) {
                state.animating = false;
                state.scrollPosition = newPosition;
                state.scrollReachedEndPosition = calcScrollPosition();
                state.slider = element + 1;
                if (onComplete) onComplete(state.slider, anim);
                if (state.scroll.clicked) scrollClear();
            },
        });
    }

    const animateThrottle = throttle(animate, 500);

    function scroll(event) {
        event.preventDefault();
        if (state.animating) return;

        const deltaY = event.deltaY;
        if (Math.abs(deltaY) < 30) return; // Ignore small scroll gestures

        if (deltaY < 0) {
            animateThrottle('up');
        } else if (deltaY > 0) {
            animateThrottle('down');
        }
    }

    function calcScrollPosition() {
        let { contentEl, sectionHeight } = state;
        let contentElHeight = contentEl.scrollHeight - sectionHeight;
        let scrollPosition = contentEl.scrollTop;
        return scrollPosition === contentElHeight ? 'down'
            : scrollPosition === 0 ? 'up'
                : '';
    }

    function scrollClick(event) {
        let scrollBarHeight = event.target.offsetHeight;
        let clickY = event.clientY;
        let clickProcent = clickY / scrollBarHeight;
        clickProcent = clickProcent.toFixed(1);
        clickProcent >= 0.5 ? animateThrottle('down') : animateThrottle('up');
    }

    function scrollSetDelta(event) {
        state.scroll.clicked = true;
        state.scroll.position = event.clientY;
    }

    function scrollMove(event) {
        if (!state.scroll.clicked) return;
        let moveY = event.clientY;
        if (moveY < state.scroll.position) {
            animateThrottle('up');
        }
        if (moveY > state.scroll.position) {
            animateThrottle('down');
        }
    }

    function scrollClear() {
        state.scroll.clicked = false;
        state.scroll.position = 0;
    }

    function resize() {
        state.sectionHeight = section.offsetHeight;
        state.contentEl.scrollTop = (state.slider - 1) * state.sectionHeight;
        state.scrollPosition = state.contentEl.scrollTop;
    }

    function init() {
        window.scrollTop = 0;
        state.beforeInitStyles.documentOverflowY = document.documentElement.style.overflowY;
        document.documentElement.style.overflowY = 'hidden';
        document.documentElement.style.height = '100%';
        document.body.style.height = '100%';

        state.beforeInitStyles.contentElOverflowY = state.contentEl.style.overflowY;
        state.beforeInitStyles.contentElOverflowX = state.contentEl.style.overflowX;

        addStylesParents(state.contentEl);

        state.contentEl.style.overflowY = 'scroll';
        state.contentEl.style.overflowX = 'hidden';
        state.contentEl.style.willChange = 'scroll-position';
        state.contentEl.scrollTop = 0;

        const hackEl = document.createElement('div');
        hackEl.style.position = 'fixed';
        hackEl.style.height = '100%';
        hackEl.style.width = '20px';
        hackEl.style.top = '0';
        hackEl.style.right = '0';
        state.contentEl.appendChild(hackEl);

        window.addEventListener('resize', resize);
        document.addEventListener('touchmove', scroll, { passive: false });
        document.addEventListener('wheel', scroll, { passive: false });
        hackEl.addEventListener('mousedown', scrollSetDelta, { passive: false });
        hackEl.addEventListener('mousemove', scrollMove, { passive: false });
        hackEl.addEventListener('mouseup', scrollClear, { passive: false });
        hackEl.addEventListener('click', scrollClick, { passive: false });
    }
    init();

    function addStylesParents(el) {
        el.style.height = '100%';
        let arr = [];
        while (el) {
            el = el.parentNode;
            if (el.nodeName === 'BODY') break;
            arr.push(el);
        }
        arr.forEach(e => e.style.height = '100%');
    }

    function destroy() {
        document.documentElement.style.overflowY = state.beforeInitStyles.documentOverflowY;
        state.contentEl.style.overflowY = state.beforeInitStyles.contentElOverflowY;
        state.contentEl.style.overflowX = state.beforeInitStyles.contentElOverflowX;
        document.documentElement.style.height = null;
        document.body.style.height = null;
        document.removeEventListener('touchmove', scroll, { passive: false });
        document.removeEventListener('wheel', scroll, { passive: false });
        window.removeEventListener('resize', resize);
    }

    return { destroy, clickOfElement };
}
